'use client';

import {
  ReactNode,
  createContext,
  useCallback,
  useState,
} from 'react';
import { PAGE_MOBILE } from '@/lib/constants';

interface MobileShellContextValue {
  currentSlide: number;
  setCurrentSlide: (slide: number) => void;
  directoryOpen: boolean;
  openDirectory: () => void;
  closeDirectory: () => void;
  pendingSlide: number | null;
  requestSlide: (slide: number) => void;
  clearPendingSlide: () => void;
}

const MobileShellContext = createContext<MobileShellContextValue>({
  currentSlide: PAGE_MOBILE.TITLE,
  setCurrentSlide: () => {},
  directoryOpen: false,
  openDirectory: () => {},
  closeDirectory: () => {},
  pendingSlide: null,
  requestSlide: () => {},
  clearPendingSlide: () => {},
});

export const MobileShellProvider = ({ children }: { children: ReactNode }) => {
  const [currentSlide, setCurrentSlide] = useState<number>(PAGE_MOBILE.TITLE);
  const [directoryOpen, setDirectoryOpen] = useState(false);
  const [pendingSlide, setPendingSlide] = useState<number | null>(null);

  const openDirectory = useCallback(() => setDirectoryOpen(true), []);
  const closeDirectory = useCallback(() => setDirectoryOpen(false), []);
  const requestSlide = useCallback((slide: number) => setPendingSlide(slide), []);
  const clearPendingSlide = useCallback(() => setPendingSlide(null), []);

  return (
    <MobileShellContext.Provider
      value={{
        currentSlide,
        setCurrentSlide,
        directoryOpen,
        openDirectory,
        closeDirectory,
        pendingSlide,
        requestSlide,
        clearPendingSlide,
      }}
    >
      {children}
    </MobileShellContext.Provider>
  );
};

export default MobileShellContext;
